import React, { useState } from 'react';
import { Box, Fade, Grid, IconButton, Slide } from '@material-ui/core';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import defaultLocales from 'globals/locales/default';
import { getUserRoleList, wait } from 'globals/utils';
import FsSimpleInput from 'ui-elements/form-elements/FsDefaultInput/FsDefaultInput';
import FsFormGridWrapper from 'ui-elements/form-elements/FsFormGridWrapper';
import FsFormGridItem from 'ui-elements/form-elements/FsFormGridItem';
import FsDefaultSelect from 'ui-elements/form-elements/FsDefaultSelect';

export interface InviteNewUserSingleRowDataProps {
  email?: string;
  role?: string;
}

export interface InviteNewUserSingleRowProps
  extends InviteNewUserSingleRowDataProps {
  onRemove?: () => void;
  onChange?: ({ email, role }: InviteNewUserSingleRowDataProps) => void;
  isOnlyOneRow?: boolean;
}

const InviteNewUserSingleRow: React.FC<InviteNewUserSingleRowProps> = ({
  email = '',
  role = '',
  onRemove,
  onChange,
  isOnlyOneRow,
}) => {
  const [inStatus, setInStatus] = useState<boolean>(true);

  const handleClick = async () => {
    setInStatus(false);
    await wait(300);
    if (onRemove) onRemove();
  };

  const handleChange = async (newValue: InviteNewUserSingleRowDataProps) => {
    if (onChange) onChange({ email, role, ...newValue });
  };

  return (
    <Slide direction="left" in={inStatus} timeout={300}>
      <Box>
        <FsFormGridWrapper>
          <FsFormGridItem style={{ flexGrow: 2 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <FsSimpleInput
                  fsVariant="outlined"
                  fullWidth
                  label={defaultLocales.email}
                  value={email}
                  onChange={(e) => handleChange({ email: e.target.value })}
                  autoFocus
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FsDefaultSelect
                  fsVariant="outlined"
                  options={getUserRoleList()}
                  fullWidth
                  label={defaultLocales.role}
                  value={role}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange({ role: e.target.value })
                  }
                />
              </Grid>
            </Grid>
          </FsFormGridItem>
          <FsFormGridItem style={{ flexGrow: 0 }}>
            <Fade in={!isOnlyOneRow} timeout={300}>
              <Box display="flex" alignItems="center">
                <IconButton onClick={handleClick} disabled={isOnlyOneRow}>
                  <DeleteOutlineOutlinedIcon />
                </IconButton>
              </Box>
            </Fade>
          </FsFormGridItem>
        </FsFormGridWrapper>
      </Box>
    </Slide>
  );
};

export default InviteNewUserSingleRow;
